import styled from '@emotion/styled';

import { RowsMixin } from './Rows.mixin';

export const Rows = styled.section`
  ${RowsMixin}
`;
